import _objectSpread from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _classCallCheck from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _assertThisInitialized from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import { TextEvent } from './TextEvent';
import { AntiEntropyManager } from './AntiEntropyManager';
import { InsertManager } from './InsertManager';
import { RemoveManager } from './RemoveManager';
import { TitleManager } from './TitleManager';

var debug = require('debug')('CRATE:Communication:TextManager:TextManager');

export var TextManager =
/*#__PURE__*/
function (_TextEvent) {
  _inherits(TextManager, _TextEvent);

  function TextManager(opts) {
    var _this;

    _classCallCheck(this, TextManager);

    var EventName = opts.EventName || 'TextManager';
    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextManager).call(this, _objectSpread({
      EventName: EventName
    }, opts)));
    _this._insertManager = new InsertManager(_objectSpread({
      TextManager: _assertThisInitialized(_assertThisInitialized(_this))
    }, opts));
    _this._removeManager = new RemoveManager(_objectSpread({
      TextManager: _assertThisInitialized(_assertThisInitialized(_this))
    }, opts));
    _this._titleManager = new TitleManager(_objectSpread({
      TextManager: _assertThisInitialized(_assertThisInitialized(_this))
    }, opts));
    _this._antiEntropyManager = new AntiEntropyManager(_objectSpread({
      TextManager: _assertThisInitialized(_assertThisInitialized(_this))
    }, opts)); //this._antiEntropyManager.sendAntiEntropyRequest()

    _this._removeBuffer = new Map(); //this._antiEntropyManager.start()

    _this.on('sendChangeTitle', function () {
      _this._titleManager.sendChangeTitle();
    });

    _this.on('setLastChangesTime', function () {
      _this._titleManager.sendChangeTitle();
    });

    return _this;
  }

  _createClass(TextManager, [{
    key: "addIdToRemoveBuffer",
    value: function addIdToRemoveBuffer(id) {
      this._removeBuffer.set(this.hashCode(JSON.stringify(id)), id);
    }
  }, {
    key: "IsItInRemoveBuffer",
    value: function IsItInRemoveBuffer(id) {
      return this._removeBuffer.has(JSON.stringify(id));
    }
  }, {
    key: "removeFromRemoveBuffer",
    value: function removeFromRemoveBuffer(id) {
      this._removeBuffer.delete(JSON.stringify(id));
    }
  }, {
    key: "close",
    value: function close() {
      this._insertManager.close();

      this._removeManager.close();

      this._titleManager.close();

      this._antiEntropyManager.close();
    }
  }]);

  return TextManager;
}(TextEvent);